export default __webpack_public_path__ + "static/media/Sikkim.3eb164c8.webp";